import React from 'react';

const CurriculumSprintCardWrapper = ({ children }) => {
  return (
    <div className="m-1 flex flex-col gap-3 md:m-4 md:mb-0">{children}</div>
  );
};

export default CurriculumSprintCardWrapper;
